import {ChangeDetectionStrategy, Component} from "@angular/core";
import {FUIAbstractFascia} from "../../abstract-fascia";

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "fui-edit-fascia",
    styleUrls: ["./edit-fascia.component.scss"],
    templateUrl: "./edit-fascia.component.html",
    standalone: false
})
export class FUIEditFasciaComponent extends FUIAbstractFascia {
}
